/*
 * @Author: qinzhenpen qzp1807@126.com
 * @Date: 2025-01-22 16:53:20
 * @LastEditors: qinzhenpen qzp1807@126.com
 * @LastEditTime: 2025-05-19 16:05:08
 * @FilePath: \tianze_web\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Storage from "vue-ls"; //缓存插件 可用于设置缓存过期时间
import App from "./App";
import router from "./router";
// import Storage from 'Vue-web-storage';
import Base64 from "@/common/base64.js";
import "es6-promise/auto";
import less from "less";
import Video from "video.js";
import "video.js/dist/video-js.css";
import Router from "vue-router";
//引入cookies组件
import VueCookies from "vue-cookies";
/*引入element组件*/
import * as util from "@/common/ulit";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 全局方法加载
import { get, post, postJSON, posts } from "@/common/request";
import { formatFloat, toDecimal, toDecimalx } from "./common/ulit";
Vue.prototype.$Base64 = Base64;
Vue.use(VueCookies);
Vue.prototype.$video = Video;
Vue.prototype.$processUrl = function(url) {
  if (!url) return;
  return this.$isHttp(url);
};
Video.Hls.xhr.beforeRequest = function(options) {
  //添加请求头token
  options.headers = options.headers || {};
  options.headers.token = Vue.prototype.$getToken();
  return options;
};
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(less);

Vue.use(ElementUI);
Vue.config.productionTip = false;

// 路径定义
Vue.prototype.$baseUrl = window.configs.API_ROOT;
Vue.prototype.$viewUrl = window.configs.VIEW_URL;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$postJSON = postJSON;
Vue.prototype.$posts = posts;

// 全局挂载num格式化函数，用的时候直接 {{xxx | toDecimalx}}
// 指定小数点后的位数 {{xxx | toDecimalx(5)}}
Vue.prototype.$numFormat = {
  toDecimal,
  toDecimalx,
  formatFloat
};

for (const [k, v] of Object.entries(util)) {
  Vue.filter(k, v);
  Vue.prototype[`$${k}`] = v;
}

//缓存插件
const options = {
  namespace: "vuejs__", // 存储的key的前缀
  name: "ls", // 命名，Vue变量.[ls]或this.[$ls]。全局：Vue.ls，上下文：this.$ls
  storage: "session" //  存储名称【三个可选项】:session, local, memory
};

Vue.use(Storage, options);

// Vue.use(Storage, {
//   prefix: 'your_app_slug_', // default `app_`
//   drivers: ['session', 'local'] // default 'local'
// });

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js